import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@next/core-lib/i18n';

import { dairyYieldScanCustomerDisplay } from '../../models/dairy-yield-scan-customer-display';
import { DairyYieldScanSummary } from '../../models/dairy-yield-scan.models';

@Component({
  selector: 'app-dairy-yield-scan-customer-details',
  templateUrl: './dairy-yield-scan-customer-details.component.html',
  styleUrls: ['./dairy-yield-scan-customer-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class DairyYieldScanCustomerDetailsComponent {
  @Input({ required: true }) summary!: DairyYieldScanSummary;
  @Input({ required: true }) headingId!: string;

  readonly customerDisplay = dairyYieldScanCustomerDisplay;
}
